import { Button } from "@/components/ui/button";
import { SquareArrowOutUpRight, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface AllocationHeaderProps {
  fundId?: string;
  fundName?: string;
  onDelete: (id: string) => void;
  allocationId: string;
  isAsset?: boolean; // Distinguish between funds and assets
  assetType?: string; // To detect multi-asset (account)
  fundKind?: string; // 'fund' | 'stock' | 'asset' | 'account'
}

export const AllocationHeader = ({ fundId, fundName, onDelete, allocationId, isAsset, assetType, fundKind }: AllocationHeaderProps) => {
  const navigate = useNavigate();
  const isAccount = (assetType || '').toLowerCase() === 'multi_asset';
  const isFundLike = (fundKind === 'fund' || fundKind === 'stock');

  return (
    <div className="flex items-start justify-between gap-2">
      <button
        onClick={() => {
          if (!fundId) return;
          if (isAccount) {
            navigate('/assets', { state: { openAccountId: fundId } });
          } else if (isFundLike) {
            navigate(`/funds/${fundId}`);
          } else {
            navigate('/assets', { state: { openAssetId: fundId } });
          }
        }}
        className="group flex items-center gap-2 font-medium text-left hover:text-primary transition-colors max-w-[calc(100%-2rem)]"
      >
        <span className="truncate">{fundName}</span>
        <SquareArrowOutUpRight className="h-3.5 w-3.5 flex-shrink-0 text-muted-foreground" />
      </button>
      <Button
        variant="ghost"
        size="icon"
        className="h-8 w-8 text-muted-foreground hover:text-foreground -mt-1 -mr-1.5"
        onClick={() => onDelete(allocationId)}
        aria-label="Delete allocation"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
;